// extracted by mini-css-extract-plugin
export default {"mainCont":"OrderHistory_mainCont__yp1Gd","TableDiv":"OrderHistory_TableDiv__1VmuE"};